<template>
  <div class="home">

    <div>
      <div class="header_desktop row">
        <div class="div_arret col-7">
          <h1>Arrêt: {{ arret.name }}</h1>
        </div>
        <div class="div_img col-5">
          <a href="https://www.cc-peva.fr/">
            <img class="logo_desktop" src="../assets/logo.png" alt="logo CC Peva"/>
          </a>
        </div>
      </div>

      <div class="header_mobile row">
        <div class="col-12">
          <a href="https://www.cc-peva.fr/">
            <img class="logo_mobile" src="../assets/logo.png" alt="logo CC Peva"/>
          </a>
        </div>
        <div class="col-12">
          <h1>Arrêt: {{ arret.name }}</h1>
        </div>
      </div>
    </div>

    <div class="perturbation-section container alert-warning" v-if="Object.values(infoTraficByRoute).some(info => info !== null && info !== undefined)">
      <div class="perturbation-content">
        <p class="perturbation-title">
          <a href="https://www.evad.fr/trafic/"
             target="_blank"
             rel="noopener noreferrer"
             class="info-badge"
             :aria-label="'Informations de trafic'"
             :title="'Informations de trafic'">
            <span aria-hidden="true">!</span>
            <span class="sr-only">Info trafic</span>
          </a>
          <span>Perturbations en cours </span>
        </p>
        <p class="perturbation-message">Les lignes affichant un badge rouge sont affectées par des perturbations.</p>
        <p class="info-trafic-link">
          <a href="https://www.evad.fr/trafic/" target="_blank" rel="noopener noreferrer">Consulter les détails des perturbations sur le site d'EVAD →</a>
        </p>
      </div>
    </div>

    <div v-if="passages !== null && passages.length > 0" class="tableau">
      <div v-if="messageErreurTrafic" class="alert alert-warning alert-dismissible fade show" role="alert">
        <span v-html="messageErreurTrafic"></span>
      </div>

      <div class="haut_tableau row g-0">
        <div class="ligne col-xl-2 col-sm-2 col-2">
          <span>LIGNE</span>
        </div>
        <div class="destination col-xl-7 col-sm-6 col-6">
          <span>DESTINATION</span>
        </div>
        <div class="prochain col-xl-3 col-sm-4 col-4">
          <span>PROCHAIN DEPART</span>
        </div>
      </div>

      <div v-if="passage.stop_depasse === false" :key="passage.trip_id" :style="listPair(index)" class="row g-0"
           v-for="(passage, index) in passages">
        <div :style="{ backgroundColor: '#' + passage.route_color }" class="ligne col-xl-2 col-sm-2 col-2">
          <span :style="{ color: '#' + passage.route_text_color }">{{ passage.route_short_name }}</span>
        </div>

        <div class="destination col-xl-7 col-sm-6 col-6">
          <div class="route-warning">
            <a v-if="infoTraficByRoute && infoTraficByRoute[passage.route_id]" href="https://www.evad.fr/trafic/"
               target="_blank" rel="noopener noreferrer"
               class="info-badge btn btn-danger btn-sm rounded-circle d-flex align-items-center justify-content-center"
               :aria-label="infoTraficByRoute[passage.route_id].title || 'Perturbations du trafic'"
               :title="infoTraficByRoute[passage.route_id].title || 'Perturbations du trafic'">
              <span aria-hidden="true" class="fw-bold">!</span>
            </a>
            <div v-else class="info-badge-placeholder"></div>
          </div>
          <div class="destination-content">
            <span>{{ passage.headsign }}</span>
            <router-link v-if="passage.vehicule_short_id !== 'null'" class="detail_vehicule"
                         :to="{name:'detailBus', params: {stopId: passage.stop_id, tripId: passage.trip_id, numSequence: passage.sequence}}">
              <span style="white-space: nowrap;">Suivre le bus <i class="fas fa-chevron-right"></i></span>
            </router-link>
          </div>
        </div>

        <div class="prochain col-xl-3 col-sm-4 col-4" v-if="passage.horaire_arrive_reel !== null">
          <span :style="{fontWeight: 'bold'}">Départ immédiat</span>
        </div>

        <div class="prochain col-xl-3 col-sm-4 col-4" v-else-if="passage.horaire_arrive_estimee !== null">
          <span v-if="passage.sequence === Math.min(...passages.map(p => p.sequence))">{{
              passage.horaire_arrive_prevu | filtreTemps
            }}</span>
          <span v-else>{{ passage.horaire_arrive_estimee | filtreTemps }}</span>
          <span class="delay-text">{{
              afficherRetard(passage.horaire_arrive_estimee, passage.horaire_arrive_prevu)
            }}</span>
        </div>

        <div class="prochain col-xl-3 col-sm-4 col-4" v-else>
          <span>{{ passage.horaire_arrive_prevu | filtreTemps }}</span>
        </div>
      </div>
    </div>
    <div v-if="passages !== null && passages.length === 0" class="pas-de-passages">
      <div class="pas-de-passages">
        <span>{{ messageErreurProchainPassage }}</span>
        <button class="retour" @click="$router.go(-1)">
          <i class="fas fa-arrow-left"></i> RETOUR
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import router from '../router'

export default {
    name: 'ProchainPassages',
    data () {
      return {
        arret: {},
        passages: null,
        timer: '',
        messageErreurProchainPassage: '',
        messageErreurTrafic: '',
        infoTraficByRoute: {},
        fetchedRouteIds: {},
       }
     },
    methods: {
      listPair: function (cases) {
        let style = {}
        if (cases % 2 !== 0) {
          style.backgroundColor = '#e7f5f8'
        }
        return style
      },
      chargerArret: function () {
        this.axios
          .get('/stops/', {
            params: {
              stopIds: this.$route.query.stopIds,
            },
            paramsSerializer: params => {
              return Object.keys(params)
                .map(key => {
                  const value = params[key];
                  if (Array.isArray(value)) {
                    return value.map(val => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&');
                  } else {
                    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                  }
                })
                .join('&');
            }
          })
          .then((succes) => {
            this.arret = succes.data
          }, (error) => {
            console.error('ERREUR de chargement de l arret', error)
          })
      },
      affichetrajet: function () {
        this.messageErreurProchainPassage = ''
        this.axios
          .get('/prochains-passages/', {
            params: {
              stopIds: this.$route.query.stopIds,
            },
            paramsSerializer: params => {
              return Object.keys(params)
                .map(key => {
                  const value = params[key]
                  if (Array.isArray(value)) {
                    return value.map(val => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&')
                  } else {
                    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
                  }
                })
                .join('&')
            }
          })
          .then((succes) => {
            if (204 === succes.status) {
              this.passages = []
              this.messageErreurProchainPassage = 'Il n\'y a pas d\'horaires dans ce sens, à cette date et à cet horaire correspondant à votre demande.'
              return
            }
            this.passages = succes.data
            this.loadInfoTraficForRoutes()
          }, (error) => {
            this.passages = []
            console.error('ERREUR de routes pour les trajets', error)
            this.messageErreurProchainPassage = 'Erreur lors du chargement des prochains passages'
          })
      },
      loadInfoTraficForRoutes () {
        if (!this.passages || !this.passages.length){
          return
        }
        const uniqueRouteIds = [...new Set(this.passages.map(p => p.route_id).filter(Boolean))]

        if (uniqueRouteIds.length === 0){
          return
        }
        this.messageErreurTrafic = ''
        let successCount = 0
        let errorCount = 0

        uniqueRouteIds.forEach(routeId => {
          if (!routeId){
            return
          }
          if (this.fetchedRouteIds[routeId]) {
            if (this.infoTraficByRoute[routeId] !== undefined) {
              successCount++
              return
            }
          }

          this.$set(this.fetchedRouteIds, routeId, true)

          this.axios.get(`/info-trafic/${routeId}`)
            .then((res) => {
              if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
                const info = res.data[0]
                this.$set(this.infoTraficByRoute, routeId, info)
              } else {
                this.$set(this.infoTraficByRoute, routeId, null)
              }
              successCount++
            })
            .catch((error) => {
              console.warn('Impossible de charger les perturbations du trafic pour routeId:', routeId, error)
              this.$set(this.infoTraficByRoute, routeId, null)
              errorCount++
              if (errorCount > 0 && successCount + errorCount === uniqueRouteIds.length) {
                this.messageErreurTrafic = 'Impossible de charger les perturbations du trafic. Consultez <a href="https://www.evad.fr/trafic/" target="_blank" rel="noopener noreferrer">evad.fr/trafic</a> pour plus de détails.'
              }
            })
        })
      },
      afficherRetard: function (estimee, prevue) {
        moment.locale('fr')
        console.log(estimee)
        console.log(prevue)
        let diff = moment(estimee).diff(moment(prevue), 'minutes')
        console.log(diff)
        if (diff > 1) {
          return 'retard : ' + diff + ' min'
        } else {
          return ''
        }
      }
    },

    mounted () {
      this.chargerArret()
      this.affichetrajet()
      this.timer = setInterval(this.affichetrajet, 60000)
      moment.updateLocale('fr', {
        relativeTime: {
          m: '%dmin',
          mm: '%dmin'
        }
      })
      router.beforeEach((to, from, next) => {
        clearInterval(this.timer)
        next()
      })
    },

    filters: {
      filtreTemps: function (horraireArrivee) {
        let date = moment(horraireArrivee)
        moment.locale('fr')
        if (date < moment().add(1, 'minute')) {
          return 'Imminent'
        } else if (date < moment().add(44, 'minute')) {
          return moment(horraireArrivee).fromNow('m')
        } else if (date < moment().endOf('day')) {
          return (moment(horraireArrivee).format('HH') + 'h' + moment(horraireArrivee).format('mm'))
        } else {
          return moment(horraireArrivee).format('DD/MM à HH') + 'h' + moment(horraireArrivee).format('mm')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
@import "../sass/variables";
@import "../../node_modules/bootstrap/scss/bootstrap";


.home {
  .header_desktop {
    @include media-breakpoint-down(sm) {
      display: none;
    }
    padding: 4% 5rem 0 5rem;
    margin: 0;

    .div_arret {
      display: flex;

      h1 {
        @include media-breakpoint-up(xl) {
          font-size: 4rem;
        }
        color: $firstcolor;
        font-family: $titlefont;
        font-weight: bold;
        margin: auto 0;
      }
    }

    .div_img {
      display: flex;

      a {
        margin: auto;
      }

      .logo_desktop {
        width: 100%;
        float: right;
      }
    }
  }

  .header_mobile {
    margin: auto;
    text-align: center;
    @include media-breakpoint-up(md) {
      display: none;
    }
    h1 {
      color: $firstcolor;
      font-family: $titlefont;
      font-weight: bold;
      margin: auto 0;
    }
  }

  .tableau {
    @include media-breakpoint-down(sm) {
      padding: 1rem;
      margin: 0;
    }
    padding: 3rem 5rem;
    width: 100%;
    margin: 0;
    .haut_tableau {
      background-color: $firstcolor;
      color: white;

      .ligne, .destination, .prochain {
        border: 0;
        background-color: $firstcolor;
        display: flex;
        align-items: center;
      }

      .ligne, .destination {
        @include media-breakpoint-up(lg) {
          font-size: 3.5rem;
        }
        font-size: 1.1rem;
        font-family: $titlefont;
      }

      .prochain {
        @include media-breakpoint-up(lg) {
          font-size: 1.65rem;
        }
        font-size: 15px;
        font-family: $titlefont;
        line-height: 100%;
      }

      span {
        margin: auto 0;
      }
    }

    .ligne {
      @include media-breakpoint-up(lg) {
        font-size: 2.5rem;
        min-height: 88px;
        padding: 0;
      }
      font-family: $titlefont;
      border-top: 1px solid white;
      padding: 10px;
      display: flex;
      align-items: center;

      span {
        margin: auto 0;
        width: 100%;
        display: block;
        text-align: center;
      }

      @media (max-width: 380px) {
        min-height: 56px;
      }
    }

    .destination {
      @include media-breakpoint-up(lg) {
        font-size: 2.5rem;
      }
      @include media-breakpoint-up(xl) {
        gap: 8px;
      }
      @include media-breakpoint-down(lg) {
        gap: 6px;
      }
      @include media-breakpoint-down(md) {
        gap: 4px;
      }
      padding: 10px;
      font-family: $textfont;
      text-align: left;
      display: flex;
      align-items: center;
      min-height: 88px;
      flex-wrap: nowrap;
      width: 100%;

      .route-warning {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        order: -1;
        margin: 0 5px 0 0;

        @include media-breakpoint-up(xl) {
          width: 34px;
          height: 34px;
        }
        @include media-breakpoint-down(lg) {
          width: 30px;
          height: 30px;
        }
        @include media-breakpoint-down(md) {
          width: 26px;
          height: 26px;
        }
        @include media-breakpoint-down(sm) {
          width: 24px;
          height: 24px;
        }
      }

      .info-badge {
        padding: 0 !important;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        width: 100%;
        height: 100%;
        line-height: 1;

        @include media-breakpoint-down(lg) {
          font-size: 0.75rem;
        }
        @include media-breakpoint-down(md) {
          font-size: 0.65rem;
        }
      }

      .info-badge-placeholder {
        width: 100%;
        height: 100%;
        flex-shrink: 0;
      }

      .destination-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 0;

        span {
          white-space: normal;
          overflow-wrap: break-word;
          word-break: normal;
        }
      }

      .detail_vehicule {
        font-size: 18px;
        color: $annexecolor;
        text-decoration: none;
        white-space: normal;
        overflow-wrap: break-word;
        word-break: normal;

        @include media-breakpoint-down(lg) {
          font-size: 16px;
        }
        @include media-breakpoint-down(md) {
          font-size: 14px;
        }

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .prochain {
      @include media-breakpoint-up(lg) {
        font-size: 1.85rem;
      }
      @include media-breakpoint-up(xl) {
        font-size: 2.4rem;
      }
      font-family: $textfont;
      display: flex;
      flex-direction: column;
      padding: 10px;
      border-bottom: 1px solid white;
      align-items: flex-end;
      justify-content: center;

      span {
        text-align: right;
        width: 100%;
      }

      .delay-text {
        font-size: 0.6em;
        color: #F08100;
        display: block;
        margin-top: 2px;
      }
    }
  }

  .pas-de-passages {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    min-height: 60vh;
    width: 90%;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    .div-oops{
      align-items: center;
      .svg-oops{
        height: 10vh;
        width: auto;
        @include media-breakpoint-down(sm) {
          font-size: 5vh !important;;
        }
      }
      span{
        font-size: 10vh;
        @include media-breakpoint-down(sm) {
          font-size: 5vh !important;;
        }
      }
    }

    .retour{
      margin-top: 20px;
      padding: 10px 30px;
      background: $firstcolor;
      color: white;
      border: none;
      border-radius: 30px;
      cursor: pointer;
    }
  }

  .perturbation-section {
    margin-top: 2rem;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .perturbation-content {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }

  .perturbation-title {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: #2c3e50;
    display: flex;
    align-items: center;
    gap: 0.8rem;

    span {
      font-family: $titlefont;
    }
  }

  .perturbation-message {
    font-style: italic;
    margin: 0;
    font-size: 0.95rem;
    color: #495057;
    line-height: 1.5;
  }

  .info-trafic-link {
    font-style: italic;
    margin: 0.5rem 0 0 0;
    font-size: 0.9rem;
    color: #6c757d;

    a {
      color: #0066cc;
      text-decoration: none;
      font-weight: 500;
      transition: all 0.2s ease;
      border-bottom: 1px solid transparent;

      &:hover {
        color: #0052a3;
        border-bottom: 1px solid #0052a3;
      }
    }
  }

  .info-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    background-color: #dc3545;
    color: white;
    border-radius: 50%;
    font-weight: 700;
    font-size: 1rem;
    text-decoration: none;
    transition: background-color 0.2s ease;
    vertical-align: middle;
    flex-shrink: 0;

    &:hover {
      background-color: #c82333;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProchainPassages.vue